import { Component, inject, Injector, OnInit } from '@angular/core';
import { Database, get, ref } from "@angular/fire/database";
import { remove, set } from 'firebase/database';
import { AuthService } from 'src/app/services/auth.service';
import { BaseComponent } from 'src/app/shared/baseComponent';

interface PlayerData {
  name: string
  role: string
  model: string
  timestamp: string
}

@Component({
  selector: 'app-exercise-edit',
  templateUrl: './exercise-edit.component.html',
  styleUrls: ['./exercise-edit.component.css']
})
export class ExerciseEditComponent extends BaseComponent implements OnInit {
  database = inject(Database);
  isAuthenticatedWithFirebase = false
  exerciseid = "" //from query parameter
  exercise: any = {}
  scenarios: any = []
  dynamicPlayerList: any[] = []
  staticPlayerList: any[] = []
  scenarioId = 0
  action = ""
  showinfo = false
  showExerciseJson = false
  playername: string = ""

  constructor(injector: Injector, private authService: AuthService) {
    super(injector)
  }

  async ngOnInit(): Promise<void> {
    this.exerciseid = this.route.snapshot.queryParamMap.get('id') || ""
    this.isAuthenticatedWithFirebase = await this.authService.initializeAuth(() => this.onSuccessfullLogin())
    await this.getData()
  }

  async signInWithGoogle() {
    this.isAuthenticatedWithFirebase = await this.authService.signInWithGoogle()
    if (this.isAuthenticatedWithFirebase) { await this.onSuccessfullLogin() }
  }

  private async onSuccessfullLogin() {
    await this.getData()
  }

  async getData() {
    this.loader.show()
    // Define the expected structure of each scenario
    type ScenarioType = {
      displayName: string;
      [key: string]: any; // Include other properties if needed
    };

    // get a list of scenarios for selection 
    const scenarioRef = ref(this.database, 'scenarios');
    const snapshotScen = await get(scenarioRef);
    if (snapshotScen.exists()) {
      this.scenarios = []
      let id = 0
      let scenariosFB = snapshotScen.val() as Record<string, ScenarioType>;;
      for (const [key, value] of Object.entries(scenariosFB)) {
        if (value['isVersion2'] == true) {
          this.scenarios.push({ id: id, name: value.displayName, key: key })
          id++
        }

      }
    }

    // get the exercise
    const exerciseRef = ref(this.database, 'exercises/' + this.exerciseid);
    const snapshot = await get(exerciseRef);
    if (snapshot.exists()) {
      this.exercise = snapshot.val();
      this.dynamicPlayerList = this.exercise.dynamicData ? BaseComponent.toArray(this.exercise.dynamicData.players) : [];
      this.staticPlayerList = this.exercise.staticData ? BaseComponent.toArray(this.exercise.staticData.players) : [];
      this.scenarioId = this.scenarios.findIndex((scenario: any) => scenario.key === this.exercise.scenarioid)
      this.action = "Update "

    } else { //exercise does not exist; get new exercise
      this.exercise = {
        name: "New Name Of Exercise",
        organization: sessionStorage.getItem('orgName'),
        teacher: sessionStorage.getItem('firstName'),
        startdate: this.getCurrentDateAsString()
      }
      this.action = "Create new "
    }
    this.loader.hide()
  }

  async updateExercise() {
    let newExercise = { ...this.exercise }
    newExercise.scenarioid = this.scenarios[this.scenarioId].key
    // convert players array back into a collection
    let players: any = {}
    if (this.exercise.players !== undefined) {
      this.exercise.players.forEach((player: any) => {
        players[player.id] = player
        delete player.id
      })
      newExercise.players = players
    }
    await set(ref(this.database, `exercises/${this.exerciseid}`), newExercise);
  }

  async removePlayerDynamic(player: any) {
    const id = player.id
    const dynamicPath = `exercises/${this.exerciseid}/dynamicData/players/${id}`

    console.log('Deleting:', id)

    try {
      await remove(ref(this.database, dynamicPath))
      console.log(`Removed from dynamic: ${id}`)

      // now refresh the data
      this.getData()
    } catch (error) {
      console.error(`Failed to delete player "${id}":`, error)
    }
  }

  async removePlayerStatic(player: any) {
    const id = player.id
    const staticPath = `exercises/${this.exerciseid}/staticData/players/${id}`

    console.log('Deleting:', id)

    try {
      await remove(ref(this.database, staticPath))
      console.log(`Removed from static: ${id}`)

      // now refresh the data
      this.getData()
    } catch (error) {
      console.error(`Failed to delete player "${id}":`, error)
    }
  }
  refresh() {
    this.getData()
  }
}
